import contentfulGql from 'js/lib/contentfulGql';

import { entWebsiteBlockAssemblyFragment } from 'bundles/ent-website/queries/EntWebsiteBlockAssembly';
import { entWebsiteDividerFragment } from 'bundles/ent-website/queries/EntWebsiteDivider';
import { entWebsiteHowFragment } from 'bundles/ent-website/queries/EntWebsiteHow';
import { entWebsiteLeaderListFragment } from 'bundles/ent-website/queries/EntWebsiteLeaderList';
import { entWebsiteMarketoModuleFragment } from 'bundles/ent-website/queries/EntWebsiteMarketoModule';
import { entWebsitePartnerListFragment } from 'bundles/ent-website/queries/EntWebsitePartnerList';
import { entWebsiteTestimonialFragment } from 'bundles/ent-website/queries/EntWebsiteTestimonial';

export const entWebsiteContactSalesFragment = contentfulGql`#graphql
  ${entWebsiteHowFragment}
  ${entWebsitePartnerListFragment}
  ${entWebsiteTestimonialFragment}
  ${entWebsiteLeaderListFragment}
  ${entWebsiteMarketoModuleFragment}
  ${entWebsiteDividerFragment}
  fragment EntWebsiteContactSales on EntWebsiteContactSales {
    slug
    hubspotCodeEmbed
    marketoModule {
      ...EntWebsiteMarketoModule
    }
    modulesCollection(limit: 5) {
      items {
          __typename
          ...EntWebsiteHow
          ...EntWebsitePartnerList
          ...EntWebsiteTestimonial
          ...EntWebsiteLeaderList
          ...EntWebsiteDivider
      }
    }
  }
`;

export const entWebsiteBlockContactSalesQuery = contentfulGql`#graphql
  ${entWebsiteBlockAssemblyFragment}
  ${entWebsiteContactSalesFragment}
  query entWebsiteBlockContactSales($id: String!, $preview: Boolean, $locale: String!) {
    entWebsiteBlockAssembly(id: $id, preview: $preview, locale: $locale) {
      ...EntWebsiteBlockAssembly
      reference {
        __typename
        ...EntWebsiteContactSales
      }
    }
  }
`;
